import { Charts } from './Charts';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const PrincipalCIDWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Charts />
        </ServicesChartsDataProvider>
    );
};

export default PrincipalCIDWrapper;
